import { Directive, Input, TemplateRef, ViewContainerRef, effect, signal } from '@angular/core';
import { FeatureFlagsStore, FeatureKey } from '@nrwl/rx-state-feature-flags';

@Directive({
  selector: '[rxHasFeature]',
  standalone: true,
})
export class RxHasFeatureDirective {
  private readonly requiredFlags = signal<FeatureKey[]>([]);
  private viewVisible = false;

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<unknown>,
    private readonly featureFlags: FeatureFlagsStore,
  ) {
    effect(() => {
      const currentFlags = this.featureFlags.flagsSignal();
      const required = this.requiredFlags();
      const visible =
        required.length === 0 ? false : required.some((flag) => currentFlags.has(flag));

      this.updateView(visible);
    });
  }

  @Input('rxHasFeature')
  set setHasFeature(value: FeatureKey | FeatureKey[] | null | undefined) {
    if (!value) {
      this.requiredFlags.set([]);
      return;
    }

    this.requiredFlags.set(Array.isArray(value) ? value : [value]);
  }

  private updateView(visible: boolean): void {
    if (visible && !this.viewVisible) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.viewVisible = true;
      return;
    }

    if (!visible && this.viewVisible) {
      this.viewContainer.clear();
      this.viewVisible = false;
    }
  }
}
